/* Style: Touch-first mobile rails for Jungle Calling. Auto-play is deliberately subtle and never removes direct swipe control. */
(() => {
  if (window.__jcMobileHomeCarouselLoaded) return;
  window.__jcMobileHomeCarouselLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selectors = [
    '.template-index [id$="__jcBest"] .popular-products-list',
    '.template-index [id$="__jcMoment"] .jc-visual-grid__grid',
    '.template-index [id$="__jcSocial"] .card-grid__grid',
    '.template-index [id$="__jcShapeStory"] .jc-feature-story__cards',
    '.template-index [data-jc-story-club-rail]',
    '.jc-subscribe-bundle__treats-grid',
    '#learning-paths .jc-visual-grid__grid',
    '#shape-guide .jc-visual-grid__grid',
    '.template-page-our-story-framework [id$="__visuals"] .jc-visual-grid__grid',
    '.template-page-our-story-framework [id$="__storyDetails"] .jc-visual-grid__grid',
    '.template-page-shop-by-moment [id$="__visuals"] .jc-visual-grid__grid'
  ];
  const manualOnlySelectors = [
    '.template-page-our-story-framework [id$="__shape"] .multicolumn-grid__wrapper',
    '.template-page-jungle-club [id$="__value"] .card-grid__grid',
    '.template-page-jungle-club [id$="__framework"] .card-grid__grid',
    '.jc-visual-grid__grid',
    '.jc-feature-story__cards',
    '.jc-mobile-story-club__rail',
    '.jc-social-reels-v2__mobile-rail',
    '.jc-social-reels__rail',
    '.jc-catalog-grid__rail',
    '[data-moment-carousel-viewport]',
    '.multicolumn--image-carousel .multicolumn-grid__wrapper'
  ];

  const setRailState = (rail, autoplay = true) => {
    const resetManualRail = () => {
      const previousBehavior = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      rail.scrollLeft = 0;
      rail.style.scrollBehavior = previousBehavior;
    };
    if (rail.dataset.jcMobileCarouselReady === 'true') {
      if (autoplay) rail.__jcMobileCarouselStart?.();
      else {
        rail.__jcMobileCarouselStop?.();
        window.requestAnimationFrame(resetManualRail);
        window.setTimeout(resetManualRail, 240);
      }
      return;
    }
    if (rail.children.length < 2) return;

    rail.dataset.jcMobileCarouselReady = 'true';
    rail.classList.add('jc-mobile-touch-rail');
    rail.setAttribute('role', 'region');
    rail.setAttribute('aria-label', 'Swipeable content carousel');
    rail.style.touchAction = 'pan-x pan-y';
    rail.style.webkitOverflowScrolling = 'touch';

    let timer = null;
    let paused = false;
    let resumeTimer = null;
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;
    let suppressClickUntil = 0;
    let activeTouchId = null;
    let controls = null;
    let controlFrame = null;

    const canAutoplay = () => mobileQuery.matches && !reducedMotionQuery.matches && document.visibilityState === 'visible';
    const clearTimer = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };
    const pause = () => {
      paused = true;
      clearTimer();
      if (resumeTimer) window.clearTimeout(resumeTimer);
    };
    const resumeLater = () => {
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        paused = false;
        start();
      }, 4200);
    };
    const getCardOffsets = () => Array.from(rail.children).map((card) => Math.max(0, card.offsetLeft - rail.offsetLeft));
    const getNearestIndex = (offsets) => {
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      offsets.forEach((offset, index) => {
        const distance = Math.abs(offset - rail.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      return nearestIndex;
    };
    const updateControls = () => {
      if (!controls) return;
      const offsets = getCardOffsets();
      const currentIndex = getNearestIndex(offsets);
      const hasOverflow = rail.scrollWidth > rail.clientWidth + 8;
      controls.hidden = !mobileQuery.matches || !hasOverflow;
      controls.querySelector('[data-jc-rail-prev]')?.toggleAttribute('disabled', currentIndex === 0);
      controls.querySelector('[data-jc-rail-next]')?.toggleAttribute('disabled', currentIndex >= offsets.length - 1);
    };
    const moveByControl = (step) => {
      const offsets = getCardOffsets();
      if (offsets.length < 2) return;
      const currentIndex = getNearestIndex(offsets);
      const targetIndex = Math.max(0, Math.min(offsets.length - 1, currentIndex + step));
      if (targetIndex === currentIndex) return;
      if (autoplay) pause();
      rail.scrollTo({ left: offsets[targetIndex], behavior: 'smooth' });
      window.setTimeout(updateControls, 320);
      if (autoplay) resumeLater();
    };
    const hasDedicatedControls = () => Boolean(
      rail.closest('[data-jc-ingredient-coverflow], [data-jc-story-carousel], [data-jc-scene-picks], [data-jc-club-carousel], [data-jc-subscribe-carousel]')
      || rail.parentElement?.querySelector('[data-jc-coverflow-prev], [data-jc-story-prev], [data-jc-scene-prev], [data-jc-club-carousel-prev], [data-jc-subscribe-carousel-prev]')
    );
    const ensureControls = () => {
      if (hasDedicatedControls() || rail.dataset.jcMobileControlsReady === 'true') return;
      rail.dataset.jcMobileControlsReady = 'true';
      controls = document.createElement('div');
      controls.className = 'jc-mobile-rail-controls';
      controls.setAttribute('aria-label', 'Carousel controls');
      controls.innerHTML = '<button type="button" data-jc-rail-prev aria-label="Previous card">←</button><button type="button" data-jc-rail-next aria-label="Next card">→</button>';
      controls.querySelector('[data-jc-rail-prev]')?.addEventListener('click', () => moveByControl(-1));
      controls.querySelector('[data-jc-rail-next]')?.addEventListener('click', () => moveByControl(1));
      rail.insertAdjacentElement('afterend', controls);
      updateControls();
    };
    const snapToNearest = () => {
      const offsets = getCardOffsets();
      if (!offsets.length) return;
      rail.scrollTo({ left: offsets[getNearestIndex(offsets)], behavior: 'smooth' });
      window.setTimeout(updateControls, 320);
    };
    const advance = () => {
      if (!canAutoplay() || paused || rail.scrollWidth <= rail.clientWidth + 8) return;
      const offsets = getCardOffsets();
      if (offsets.length < 2) return;
      const currentIndex = getNearestIndex(offsets);
      const nextIndex = currentIndex >= offsets.length - 1 ? 0 : currentIndex + 1;
      rail.scrollTo({ left: offsets[nextIndex], behavior: 'smooth' });
      window.setTimeout(updateControls, 320);
    };
    const start = () => {
      clearTimer();
      if (!canAutoplay() || paused || rail.scrollWidth <= rail.clientWidth + 8) return;
      timer = window.setInterval(advance, 3600);
    };

    const beginDrag = (clientX) => {
      if (autoplay) pause();
      dragging = true;
      moved = false;
      rail.dataset.jcGestureState = 'start';
      rail.dataset.jcPreviousSnapType = rail.style.scrollSnapType || '';
      rail.dataset.jcPreviousScrollBehavior = rail.style.scrollBehavior || '';
      rail.style.scrollSnapType = 'none';
      rail.style.scrollBehavior = 'auto';
      startX = clientX;
      startScroll = rail.scrollLeft;
    };
    const moveDrag = (clientX) => {
      if (!dragging) return;
      const delta = clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      if (moved) {
        rail.dataset.jcGestureState = 'move';
        rail.scrollLeft = startScroll - delta;
      }
    };
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      rail.dataset.jcGestureState = moved ? 'end' : 'tap';
      rail.style.scrollSnapType = rail.dataset.jcPreviousSnapType || '';
      rail.style.scrollBehavior = rail.dataset.jcPreviousScrollBehavior || '';
      delete rail.dataset.jcPreviousSnapType;
      delete rail.dataset.jcPreviousScrollBehavior;
      if (moved) suppressClickUntil = Date.now() + 320;
      window.requestAnimationFrame(snapToNearest);
      if (autoplay) resumeLater();
    };
    const onPointerDown = (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      beginDrag(event.clientX);
      try { rail.setPointerCapture?.(event.pointerId); } catch (error) {}
    };
    const onPointerMove = (event) => moveDrag(event.clientX);
    const onPointerEnd = (event) => {
      try { rail.releasePointerCapture?.(event.pointerId); } catch (error) {}
      endDrag();
    };
    const onTouchStart = (event) => {
      const touch = event.changedTouches?.[0];
      if (!touch) return;
      activeTouchId = touch.identifier;
      beginDrag(touch.clientX);
    };
    const onTouchMove = (event) => {
      const touch = Array.from(event.touches || []).find((item) => item.identifier === activeTouchId) || event.touches?.[0];
      if (!touch) return;
      moveDrag(touch.clientX);
      if (moved) event.preventDefault();
    };
    const onTouchEnd = () => {
      activeTouchId = null;
      endDrag();
    };
    const onMouseDown = (event) => {
      /* Modern browsers already use the pointer path. Keeping this fallback out
         of that path preserves ordinary anchor clicks while drag gestures still
         suppress clicks after movement. */
      if (window.PointerEvent || event.button !== 0) return;
      beginDrag(event.clientX);
      event.preventDefault();
    };
    const onMouseMove = (event) => moveDrag(event.clientX);
    const onMouseUp = () => endDrag();

    rail.addEventListener('pointerdown', onPointerDown);
    rail.addEventListener('pointermove', onPointerMove);
    rail.addEventListener('pointerup', onPointerEnd);
    rail.addEventListener('pointercancel', onPointerEnd);
    rail.addEventListener('touchstart', onTouchStart, { passive: true });
    rail.addEventListener('touchmove', onTouchMove, { passive: false });
    rail.addEventListener('touchend', onTouchEnd, { passive: true });
    rail.addEventListener('touchcancel', onTouchEnd, { passive: true });
    rail.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove, { passive: true });
    window.addEventListener('mouseup', onMouseUp, { passive: true });
    rail.addEventListener('click', (event) => {
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);
    rail.addEventListener('scroll', () => {
      window.cancelAnimationFrame(controlFrame);
      controlFrame = window.requestAnimationFrame(updateControls);
    }, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    mobileQuery.addEventListener('change', updateControls);
    ensureControls();
    if (autoplay) {
      rail.addEventListener('mouseenter', pause, { passive: true });
      rail.addEventListener('mouseleave', resumeLater, { passive: true });
      rail.addEventListener('focusin', pause);
      rail.addEventListener('focusout', resumeLater);

      document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' ? start() : clearTimer());
      mobileQuery.addEventListener('change', start);
      reducedMotionQuery.addEventListener('change', start);
      window.addEventListener('resize', start, { passive: true });
    }

    rail.__jcMobileCarouselStart = start;
    rail.__jcMobileCarouselStop = clearTimer;
    if (autoplay) {
      start();
      window.setTimeout(start, 420);
      window.setTimeout(start, 1600);
      window.setTimeout(updateControls, 500);
    } else {
      window.requestAnimationFrame(resetManualRail);
      window.setTimeout(resetManualRail, 240);
      window.setTimeout(updateControls, 500);
    }
  };

  const initialise = () => {
    manualOnlySelectors.forEach((selector) => document.querySelectorAll(selector).forEach((rail) => setRailState(rail, false)));
    selectors.forEach((selector) => document.querySelectorAll(selector).forEach((rail) => setRailState(rail, true)));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  window.addEventListener('load', () => window.setTimeout(initialise, 180), { once: true });
  window.setTimeout(initialise, 900);
  window.setTimeout(initialise, 2200);
  window.setTimeout(initialise, 4200);
  document.addEventListener('shopify:section:load', initialise);
})();
